export function parsePortTargets(value: string): string[] {
    return value
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(line => line.length > 0);
}
